import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { LoggedOutComponent } from './components/loggedout/loggedout.component';
import { LOGGEDOUT_ROUTES } from '../loggedout/loggedout.routing'


@NgModule({
  declarations: [
    LoggedOutComponent
  ],
  imports: [
      CommonModule,
      RouterModule.forChild(LOGGEDOUT_ROUTES)
  ]
})
export class LoggedoutModule { }
